import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export function headerMobile() {
  $('.header__sidebar').on('click', function(e) {
    if(e.target == this){
      $('#sidebar-toggle').prop('checked', false)
      $('header').removeClass('header--sidebar')
      clearAllBodyScrollLocks()
    }
  })

  $('#sidebar-toggle').on('change', function(){
    if($('#sidebar-toggle').prop('checked')){
      $('header').addClass('header--sidebar');
      disableBodyScroll($('.header__menu').get(0))
    }else{
      $('header').removeClass('header--sidebar');
      clearAllBodyScrollLocks()
    }
  })  
}

export function headerObserver(){
  const root = document.querySelector('.hero__observer');
  if(root){
    let options = {
      threshold: 1,
    }
    let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.intersectionRatio == 0)
        $('header').removeClass('header--glassy')
      else if(entry.intersectionRatio == 1)
        $('header').addClass('header--glassy')
      })
    }, options)
    observer.observe(root)
  }else{
    $('header').removeClass('header--glassy')
  }
}